import { render, staticRenderFns } from "./ProfileRoute.vue?vue&type=template&id=26aaa8c8&"
import script from "./ProfileRoute.vue?vue&type=script&lang=js&"
export * from "./ProfileRoute.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports